import createReactComponent from '../createReactComponent';
var Folder = createReactComponent('Folder', [['path', {
  d: 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z',
  key: 'kebh6j'
}]]);
export default Folder;